import { useState } from "react";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import Modal from "../../../molecules/Modal";
import NoData from "../../../molecules/NoData";
import useModal from "../../../../hooks/useModal";
import EditQYR from "./quejas_reportes/EditQYR";
import { useSession } from "../../../../context/SessionContext";
import ExpandedCell from "../../../atoms/ExpandedCell";

const QuejasYReportesTable = ({ data, refetch, loading }) => {
    const { user } = useSession();
    const [selected, setSelected] = useState(null);
    const { open, isOpen, close } = useModal();

    const handleOpenResolve = (row) => {
        open();
        setSelected(row);
    };

    const handleClose = () => {
        close();
        setSelected(null);
    };

    const columns = [
        {
            name: "Queja/reporte",
            cell: (row) => (
                <div className="flex flex-col">
                    <strong> {row.description} </strong>
                    <ExpandedCell text={row.comment_user} />
                </div>
        ),},
        {
            name: "Fecha de reporte",
            cell: (row) => (
                <div>
                    <strong className={`${row.service_date ? "bg-green-500" : "bg-red-500"} rounded-md p-2 text-white font-bold`}> {row.incident_date} </strong>
                </div>
        ),},
        {
            name: "Fecha de resolución",
            cell: (row) => (
                <button
                    onClick={row.service_date ? null : () => handleOpenResolve(row)}
                    disabled={user?.role === "Resident" ? true : false}
                >
                    <strong className={`${row.service_date ? "bg-green-500" : "bg-red-500"} rounded-md p-2 text-white font-bold`}>
                        {row.service_date ? row.service_date : (user?.role !== "Resident" ? "Resolver" : row.status)}
                    </strong>
                </button>
        ),},
        {
            name: "Comentarios del servicio",
            cell: (row) => <ExpandedCell text={row.comment_admin} />,
        },
    ];

    return (
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
            {isOpen && selected !== null &&
                <Modal title="Editar inmueble" onClose={handleClose}>
                    <EditQYR QOR={selected} refetch={refetch} onClose={handleClose} />
                </Modal>
            }
        </>
    );
};

export default QuejasYReportesTable;
